import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';
import { Grid } from '@change/ds-layout';
import { cn } from '@change/ds-utils';

import { useI18n } from '@change-corgi/core/react/i18n';

import { usePetitionEditPageData } from 'src/app/pages/petitionEditV2/pageContext';
import { ScrollContainerV2 } from 'src/app/shared/components/ScrollContainer';

import { PetitionStrengthCard, TipCard } from './components';
import { useGetPetitionStrengthTips } from './hooks/useGetPetitionStrengthTips';

export function StrengthTips(): JSX.Element | null {
	const { translate } = useI18n();
	const {
		data: { score },
	} = usePetitionEditPageData();
	const tips = useGetPetitionStrengthTips();

	if (tips.length === 0) {
		return null;
	}

	return (
		<div className="border bg-background-overlay">
			<Grid className="!gap-0 !p-0 lg:!gap-0">
				<div className="col-span-full flex flex-col gap-4 px-4 py-6 pr-0 md:px-12 md:py-6">
					<Text variant="heading" size="x-small">
						Strengthen your petition
					</Text>
					<ScrollContainerV2
						label={translate('corgi.petition.details.strength_score.title')}
						backgroundColor="var(--background-overlay-color)"
						sx={{
							width: 'max-content',
							maxWidth: '100%',
						}}
					>
						<PetitionStrengthCard score={score || 0} />
						{tips.map((tip, index) => {
							return (
								<div key={`tip-card-${tip.type}`} className={cn({ 'mr-4 md:m-0': index === tips.length - 1 })}>
									<TipCard tip={tip} />
								</div>
							);
						})}
					</ScrollContainerV2>
				</div>
			</Grid>
		</div>
	);
}
